import { create } from "zustand";
import { persist } from "zustand/middleware";

type ConsentValue = "pending" | "accepted" | "declined";

interface ConsentStore {
  analyticsConsent: ConsentValue;
  setConsent: (value: ConsentValue) => void;
}

export const useConsentStore = create<ConsentStore>()(
  persist(
    (set) => ({
      analyticsConsent: "pending",
      setConsent: (value) => set({ analyticsConsent: value }),
    }),
    {
      name: "ispyfr-consent",
      version: 1,
      partialize: (state) => ({ analyticsConsent: state.analyticsConsent }),
    },
  ),
);
